<template>
    <v-container flat>
        <v-row no-gutters class="my-3 justify-center">
            <v-col cols="2" v-if="companyId">
                <v-btn-primary block @click="startCreateUser" id="Add" data-cy="UserTable-add">
                    Ajouter
                </v-btn-primary>
            </v-col>
            <v-col class="pl-2" cols="2">
                <v-select
                    v-model="userType"
                    label="Types de personnes"
                    :items="userTypes"
                    item-value="value"
                    elevation="0"
                    outlined
                    hide-details
                    data-cy="UserTable-userType"
                    density="compact"
                    :item-title="(item) => item.name"
                >
                </v-select>
            </v-col>
            <template v-if="userTypeSelectable">
                <v-col cols="2" class="pl-2">
                    <v-select
                        v-model="selected"
                        :items="items"
                        item-value="value"
                        item-title="text"
                        label="Filtre"
                        outlined
                        hide-details
                        elevation="0"
                        data-cy="UserTable-selected"
                        density="compact"
                    />
                </v-col>
                <v-col cols="2" class="pl-2" v-if="selected === 'users'">
                    <oss-company-selector
                        v-model="selectedCompanies"
                        :multiple="true"
                        :items="allAvailableCompanies"
                        :label="'Société'"
                        data-cy="UserTable-selectedCompanies"
                    />
                </v-col>
            </template>
            <v-col class="pl-2">
                <v-text-field
                    v-model="search"
                    label="Recherche"
                    outlined
                    hide-details
                    data-cy="UserTable-search"
                    density="compact"
                    append-inner-icon="$search"
                    clearable
                    @click:clear="search = ''"
                />
            </v-col>
            <!-- <v-col cols="1" class="text-center">
                <v-btn
                    elevation="0"
                    icon
                    fab
                    @click="initialize()"
                    class="mx-2"
                        size="small"
                    data-cy="UserTable-trash"
                >
                    <v-icon  size="small">$oss-trash</v-icon>
                </v-btn>
            </v-col> -->
            <v-col cols="1" class="d-flex justify-end align-center" v-if="!$vuetify.display.mobile">
                <TutorialButtonDialog :starterComponents="'UserTable;'"> </TutorialButtonDialog>
            </v-col>
        </v-row>
        <div :style="'max-height:' + maxHeight + ';' + 'overflow:auto'">
            <v-row
                no-gutters
                class="d-flex justify-center"
                data-cy="UserTable-UsersList"
                v-if="userType !== 'ASSOCIATE_USER'"
                v-for="item in users"
                :key="item.id"
            >
                <v-col cols="8">
                    <v-card
                        class="default_card mt-0 mb-4 mx-0"
                        @click="editUser(item.id)"
                        style="cursor: pointer"
                    >
                        <v-row no-gutters :data-cy="'UserTable-editUser-' + item.id">
                            <v-col
                                cols="2"
                                v-if="!$vuetify.display.mobile"
                                class="d-flex align-center justify-center"
                            >
                                <v-avatar color="secondary">
                                    {{ getUserBigram(item) }}
                                </v-avatar>
                            </v-col>
                            <v-col cols="8">
                                <div
                                    class="d-flex align-center primary--text justify-space-between"
                                >
                                    <span
                                        data-cy="UserTable-UserName"
                                        :class="$vuetify.display.mobile ? 'ml-2' : ''"
                                        style="font-weight: bold; font-size: 16pt"
                                        >{{ getTitle(item) }}
                                        <v-chip
                                            label
                                            color="primary"
                                            v-if="isOwner(item)"
                                            class="ml-2"
                                            size="small"
                                            variant="outlined"
                                            >Propriétaire</v-chip
                                        ></span
                                    >
                                    <span
                                        class="tag mr-2"
                                        style="opacity: 0.6"
                                        v-if="item.profile"
                                        >{{ getProfileName(item) }}</span
                                    >
                                    <span
                                        class="tag mr-2"
                                        style="opacity: 0.6"
                                        v-else-if="item.type"
                                        >{{ $t("user.type." + item.type) }}</span
                                    >
                                </div>
                                <div
                                    class="d-flex align-center justify-space-between"
                                    v-if="item.email || isRootProfile"
                                >
                                    <span
                                        :class="$vuetify.display.mobile ? 'ml-2' : ''"
                                        style="opacity: 0.6"
                                        v-if="item.email"
                                        >{{ getDisplayEmail(item.email) }}</span
                                    >
                                    <span
                                        class="tag tag-secondary mr-2"
                                        style="opacity: 0.6"
                                        v-if="isRootProfile"
                                        >{{
                                            item.company && item.company.name
                                                ? item.company.name
                                                : "-"
                                        }}</span
                                    >
                                </div>
                            </v-col>
                            <v-col cols="2">
                                <v-row no-gutters v-if="userAllowedToModify">
                                    <v-col
                                        :cols="canUnlinkUser(item) ? 6 : 12"
                                        class="d-flex justify-center pa-0"
                                        @click="editUser(item.id)"
                                        style="cursor: pointer"
                                    >
                                        <v-tooltip location="bottom">
                                            <template v-slot:activator="{ props }">
                                                <v-btn-icon
                                                    icon="$edit"
                                                    large
                                                    color="secondary"
                                                    v-bind="props"
                                                />
                                            </template>
                                            <span>Modifier</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col
                                        v-if="canUnlinkUser(item)"
                                        cols="6"
                                        class="d-flex justify-center pa-0"
                                        @click.stop="
                                            selectedUser = item;
                                            dialogDisconnectUser = true;
                                        "
                                        style="cursor: pointer"
                                    >
                                        <v-tooltip location="bottom">
                                            <template v-slot:activator="{ props }">
                                                <v-btn-icon
                                                    icon="$fa-unlink"
                                                    large
                                                    color="new_red"
                                                    v-bind="props"
                                                    :disabled="isOwnerSomewhere(item)"
                                                />
                                            </template>
                                            <span>
                                                {{
                                                    isOwnerSomewhere(item)
                                                        ? "Droits non modifiables pour le propriétaire du dossier"
                                                        : "Retirer les droits de connexion"
                                                }}
                                            </span>
                                        </v-tooltip>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <!-- <v-col
                                cols="12"
                                class="my-0 pa-2 d-flex justify-center"

                            >
                                <oss-card :txtIcon="getUserBigram(item)">
                                    <template #left>
                                        <v-col
                                            cols="10"
                                            class="py-0"
                                            @click="editUser(item.id)"
                                            style="cursor: pointer"
                                            :data-cy="'UserTable-editUser-' + item.id"
                                        >
                                            <div
                                                class="d-flex align-center primary--text justify-space-between"
                                            >
                                                <span
                                                    :class="$vuetify.display.mobile ? 'ml-2' : ''"
                                                    style="font-weight: bold; font-size: 16pt"
                                                    >{{ getTitle(item) }}
                                                    <v-chip
                                                        label
                                                        outlined
                                                        color="primary"
                                                        v-if="isOwner(item)"
                                                        class="ml-2"
                                                        size="small"
                                                        >Propriétaire</v-chip
                                                    ></span
                                                >
                                                <span
                                                    class="tag mr-2"
                                                    style="opacity: 0.6"
                                                    v-if="item.profile"
                                                    >{{ getProfileName(item) }}</span
                                                >
                                                <span
                                                    class="tag mr-2"
                                                    style="opacity: 0.6"
                                                    v-else-if="item.type"
                                                    >{{ $t("user.type." + item.type) }}</span
                                                >
                                            </div>
                                            <div
                                                class="d-flex align-center justify-space-between"
                                                v-if="item.email || isRootProfile"
                                            >
                                                <span
                                                    :class="$vuetify.display.mobile ? 'ml-2' : ''"
                                                    style="opacity: 0.6"
                                                    v-if="item.email"
                                                    >{{ getDisplayEmail(item.email) }}</span
                                                >
                                                <span
                                                    class="tag tag-secondary mr-2"
                                                    style="opacity: 0.6"
                                                    v-if="isRootProfile"
                                                    >{{
                                                        item.company && item.company.name
                                                            ? item.company.name
                                                            : "-"
                                                    }}</span
                                                >
                                            </div>
                                        </v-col>
                                    </template>
                                    <template #right>
                                        <template v-if="userAllowedToModify">
                                            <v-col
                                                cols="6"
                                                class="d-flex justify-center pa-0"
                                                @click="editUser(item.id)"
                                                style="cursor: pointer"
                                            >
                                                <v-btn-icon icon="$edit" large color="secondary" />
                                            </v-col>
                                            <v-col
                                                cols="6"
                                                class="d-flex justify-center pa-0"
                                                @click.stop="
                                                    selectedUser = item;
                                                    dialogDisconnectUser = true;
                                                "
                                                style="cursor: pointer"
                                            >
                                                <v-btn-icon icon="$fa-unlink" large color="new_red" />
                                            </v-col>
                                        </template>
                                        <v-col v-else />
                                    </template>
                                </oss-card>
                            </v-col> -->
                        </v-row>
                    </v-card>
                    <!-- <v-row no-gutters v-if="users.length < userTotalItems">
                        <v-col
                            cols="12"
                            v-intersect="onIntersectNext"

                        >
                            <v-card class="default_card" elevation="0" pa-0 style="margin: 5px">
                                <v-row class="d-flex align-center">
                                    <v-col cols="2">
                                        <v-skeleton-loader type="avatar" />
                                    </v-col>
                                    <v-col cols="9">
                                        <v-skeleton-loader type="heading" class="my-3" />
                                        <v-skeleton-loader type="text" class="my-auto" />
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row> -->
                </v-col>
            </v-row>
            <v-row no-gutters class="d-flex justify-center" v-else>
                <v-col cols="12">
                    <AssociatesTable :company="companyDetails"> </AssociatesTable>
                </v-col>
            </v-row>
        </div>

        <oss-dialog
            v-model="addUserDialog"
            :actions="actions"
            :title="'Création d\'un nouvel utilisateur'"
            @valid="upsertUser"
            prefixDataCy="UserTable-create"
            width="60vw"
        >
            <UserEditionLight
                v-if="addUserDialog"
                :actions="actions"
                id="Dialog"
                ref="userEditionLight"
            />
        </oss-dialog>
        <oss-dialog
            v-model="dialogDisconnectUser"
            :title="'Retirer les droits de connexion'"
            @valid="removeUser"
            :validTitle="'Retirer les droits de connexion de cet utilisateur'"
            width="1000px"
        >
            <v-row class="mx-2">
                <v-col>
                    Vous êtes sur le point de retirer les droits de connexion de
                    <b>{{ getUserDisplayName(selectedUser) }}</b> à la plateforme. Cet utilisateur
                    ne sera pas supprimé de votre société mais ne pourra plus se connecter.
                </v-col>
            </v-row>
        </oss-dialog>
    </v-container>
</template>
<script lang="ts">
import { State2Way } from "@/decorators";
import { Apollo } from "@/decorators";
import { User } from "../../store/store";
import gql from "graphql-tag";

import USERS_FILTER_QUERY from "../../graphql/user/FilterUsers.gql";
import MODIFY_USER_STATUS from "../../graphql/user/ModifyUserStatus.gql";

import UserEditionLight from "../user/UserEditionLight.vue";
import ossCompanySelector from "../ossComponents/ossCompanySelector.vue";
import AssociatesTable from "../user/AssociatesTable.vue";
import TutorialButtonDialog from "../tutorial/TutorialButtonDialog.vue";

import { getUserBigram, getUserDisplayName } from "../../services/userServices";
import { DialogAction } from "../../services/dialogAction";
import { getProfileName } from "../../services/profile";
import { getDisplayEmail } from "../../services/emailServices";
import { Component, Vue, toNative, Prop, Watch, Ref } from "vue-facing-decorator";
import emitter from "@/services/emitter";

@Component({
    components: {
        UserEditionLight,
        ossCompanySelector,
        AssociatesTable,
        TutorialButtonDialog,
    },
})
export class UserTable extends Vue {
    @Prop({ type: String }) readonly companyId: String;
    @Prop({ type: String }) readonly mode: String;
    @Prop({ type: String }) readonly title: String;
    @Prop({ default: true }) readonly userTypeSelectable: boolean;
    @Prop({ default: false }) readonly admin: boolean;
    @Ref() userEditionLight: any;

    firstRequestDone = false;
    loadingStateNext = true;
    userTotalItems = 0;
    dialogDisconnectUser = false;
    dialogCompanyTable: boolean = false;
    selectedCompanies: any = [];
    select: string = "";

    items = [
        {
            text: "Collaborateurs du cabinet",
            value: "collaborators",
        },
        {
            text: "Tous les Utilisateurs",
            value: "users",
        },
    ];

    selected: string = "collaborators";

    get isRootProfile() {
        return this.currentUser.isRoot;
    }

    get allAvailableCompanies() {
        return this.$store.state.user.allAvailableCompanies;
    }

    selectedUser: any = {
        name: null,
        id: null,
    };

    actions = {
        action: new DialogAction(),
    };

    userType = "";

    userTypes = [
        {
            value: "",
            name: "Tous",
        },
        {
            value: "NATURAL_PERSON",
            name: "Personne physique",
        },
        {
            value: "LEGAL_PERSON",
            name: "Personne morale",
        },
        {
            value: "WITH_ACCOUNT",
            name: "Avec un compte",
        },
        {
            value: "ASSOCIATE_USER",
            name: "Associé",
        },
    ];

    initialize() {
        this.selectedCompanies = [];
        this.selected = "collaborators";
        this.search = "";
        this.userType = "WITH_ACCOUNT";

        this.pagination.page = 1;
        this.firstRequestDone = false;
        this.users = [];
    }

    get inAdmin() {
        return this.$route.fullPath.startsWith("/admin");
    }

    get userAllowedToModify() {
        return this.inAdmin;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAccountingUser() {
        return this.currentUser.isAccountingUser;
    }

    get isRootUser() {
        return this.currentUser.isRoot;
    }

    get isAccountingClient() {
        return this.currentUser.isAccountingClient;
    }

    get isInAccountingFirm() {
        return this.currentUser.isInAccountingFirm;
    }

    getDisplayEmail(email) {
        return getDisplayEmail(email);
    }

    getUserBigram(user) {
        return getUserBigram(user);
    }

    getUserDisplayName(user) {
        return getUserDisplayName(user);
    }

    getTitle(user) {
        let title = "";
        if (user.firstname) title = user.firstname;
        if (user.marriedName) {
            if (title) title += " ";
            title += user.marriedName;
        } else if (user.lastname) {
            if (title) title += " ";
            title += user.lastname;
        }
        return title;
    }

    getProfileName(user) {
        if (user?.profile) {
            return getProfileName(this, user.profile);
        }
        return "XXXX";
    }

    get headers() {
        if (this.mode === "customer") {
            return [
                { text: "Profile", value: "profile.name" },
                { text: "Email", value: "email" },
                { text: "Firstname", value: "firstname" },
                { text: "Lastname", value: "lastname" },
            ];
        }
        return [
            { text: "Company", value: "company.name", sortable: false },
            { text: "Profile", value: "profile.name" },
            { text: "Email", value: "email" },
            { text: "Firstname", value: "firstname" },
            { text: "Lastname", value: "lastname" },
        ];
    }

    loading: Boolean = false;

    get companyIds() {
        if (this.selected === "collaborators") {
            return [this.companyId];
        }
        if (this.selectedCompanies?.length) {
            return this.selectedCompanies.map((company: { id: any }) => company.id);
        }
        return this.allAvailableCompanies.map((company: { id: any }) => company.id);
    }

    get maxHeight() {
        const innHeight = window.innerHeight;
        const vhHeight = (200 / innHeight) * 100;
        const maxHeight_vh = 100 - vhHeight;

        return maxHeight_vh + "vh";
    }

    @State2Way("updateUserSearch", "userFilter.search")
    search!: string;

    @State2Way("updateUserPagination", "userFilter.pagination")
    pagination!: any;

    @Apollo({
        query: USERS_FILTER_QUERY,
        debounce: 500,
        fetchPolicy: "network-only",
        // loadingKey: 'loading',
        variables() {
            // debugger
            // console.log("Jalapeños");
            // console.log(this.search ? this.search : undefined);
            // console.log(this.pagination.rowsPerPage > 0 ? this.pagination.rowsPerPage : 100);
            // console.log(this.pagination.rowsPerPage * (this.pagination.page - 1));
            // console.log(this.formatOrderBy());
            // console.log(this.companyIds);
            // console.log(this.userType === "WITH_ACCOUNT" ? null : undefined);
            // console.log(
            //     this.userType && this.userType !== "WITH_ACCOUNT" ? this.userType : undefined,
            // );
            return {
                q: this.search ? this.search : undefined,
                first: this.pagination.rowsPerPage > 0 ? this.pagination.rowsPerPage : 100,
                skip: this.pagination.rowsPerPage * (this.pagination.page - 1),
                orderBy: this.formatOrderBy(),
                companyIds: this.companyIds,
                email_not: this.userType === "WITH_ACCOUNT" ? null : undefined,
                userType:
                    this.userType && this.userType !== "WITH_ACCOUNT" ? this.userType : undefined,
            };
        },
        skip() {
            return this.userType === "ASSOCIATE_USER";
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.firstRequestDone = true;
            this.loading = loading;
            if (data?.users?.length) {
                // if (this.pagination.page === 1) {
                //     this.users = []
                // }
                this.users.push(...data.users);
                this.userTotalItems =
                    data.usersConnection && data.usersConnection.aggregate
                        ? data.usersConnection.aggregate.count
                        : 0;

                this.users.sort((a, b) => {
                    if (a.firstname < b.firstname) {
                        return -1;
                    }
                    if (a.firstname > b.firstname) {
                        return 1;
                    }
                    return 0;
                });
            } else {
                this.users = [];
            }
        },
    })
    users = [];

    @Apollo({
        query: gql`
            query companyDetails($id: ID!) {
                company(where: { id: $id }) {
                    id
                    buildings
                    legalForm
                    taxSystem
                    shareCapital
                    shareTotal
                    companyUsers {
                        user {
                            id
                            firstname
                            marriedName
                            lastname
                            email
                            type
                        }
                        investment
                    }
                }
            }
        `,
        variables() {
            return {
                id: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loadingDocument = loading;
            if (!loading) {
                if (data?.company) {
                    this.companyDetails = data.company;
                } else {
                    this.companyDetails = null;
                }
            }
        },
    })
    companyDetails: any = null;

    addUserDialog = false;

    beforeMount() {
        this.pagination.page = 1;
        this.pagination.rowsPerPage = 50;
    }

    refresh() {
        if (this.$apollo.queries && this.$apollo.queries.users) {
            this.pagination.page = 1;
            this.users = [];
            this.$apollo.queries.users.refetch();
        }
    }

    async upsertUser() {
        // Temporary fix for the auto test on user edition light
        await this.$refs.userEditionLight.upsertUser(false);
        this.refresh();
        this.addUserDialog = false;
    }

    formatOrderBy() {
        const fieldName = this.pagination.sortBy[0] || "lastname";
        let direction = "";
        if (fieldName !== "updatedAt") {
            direction = this.pagination.descending[0] ? "_DESC" : "_ASC";
        } else {
            direction = this.pagination.descending[0] ? "_ASC" : "_DESC";
        }
        return fieldName + direction;
    }

    onIntersectNext(_, entries, observer) {
        if (this.firstRequestDone) {
            if (entries[0].isIntersecting) {
                this.loadingStateNext = true;
                this.pagination.page += 1;
                console.log(this.pagination.rowsPerPage);
            }
        }
    }

    async removeUser() {
        if (this.selectedUser?.id) {
            await this.$apollo.mutate({
                mutation: MODIFY_USER_STATUS,
                variables: {
                    userId: this.selectedUser.id,
                    companyId: this.companyId,
                    status: "DELETE",
                },
            });
            this.dialogDisconnectUser = false;
            this.refresh();
        }
    }

    @Watch("search")
    @Watch("companyIds", { deep: true })
    @Watch("userType")
    @Watch("selected")
    clearBySearch() {
        this.pagination.page = 1;
        this.firstRequestDone = false;
        this.users = [];
    }

    @Watch("companyId")
    emptyUsers() {
        this.users = [];
    }

    startCreateUser() {
        if (this.inAdmin) {
            // if (this.$route.name === "companies-edition") {
            //     return this.$router.push({ name: 'create-accounting-user', params: {companyId: `${this.companyId}`}})
            // }
            return this.$router.push({
                name: "create-user",
                params: { companyId: `${this.companyId}` },
            });
        }
        this.addUserDialog = true;
    }

    isOwner(user) {
        const userWithRoles = user.companyUsers.filter((cu) => cu.role);
        if (userWithRoles.length) {
            return !!userWithRoles.find((cu) => cu.company.id === this.companyId);
        }
        return false;
    }

    isOwnerSomewhere(user) {
        if (!user || !Array.isArray(user.companyUsers)) return false;
        return user.companyUsers.some((cu) => !!cu.role);
    }

    startTuto() {
        emitter.$emit("setTutorialData", [
            {
                ref: document.getElementById("Add"),
                title: "Créer un nouvel utilisateur",
                pages: [
                    {
                        text: "Pour ajouter un utilisateur cliquez ici ",
                        position: "right",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("Dialog"),
                title: "Créer un nouvel utilisateur",
                pages: [
                    {
                        text: "Renseignez les informations demandés puis activez le compte si vous souhaitez que cette utilisateur puisse se connecter sur bobbee en renseignant le mail de connexion ainsi que son mot de passe. Vous devez également indiquer le « profil utilisateur » qui permet de définir les droits d’acces aux différentes fonctionnalités ",
                        position: "right",
                        align: "center",
                    },
                ],
            },
        ]);
    }

    editUser(userId) {
        this.$router.push({
            name: this.admin || this.inAdmin ? "admin-users-details" : "users-details",
            params: { id: userId },
        });
    }

    /**
     * Check if the current user can unlink another user.
     */
    canUnlinkUser(user: any): boolean {
        const profileComparisonWithCurrentProfile = user.profile?.comparisonWithCurrent;
        if (
            profileComparisonWithCurrentProfile === "LOWER" ||
            profileComparisonWithCurrentProfile === "EQUAL"
        ) {
            return this.isRootUser || this.isInAccountingFirm || this.isAccountingClient;
        }

        return false;
    }
}

export default toNative(UserTable);
</script>
